<section>
    <div id="main-wrapper">
        <div class="site-wrapper-reveal">
            <div class="position-relative w-100">
                <div class="d-flex align-items-center h-100 w-100">
                    <img src="../../../assets/images/banners/about-banner.png"
                        class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="banners about" />
                    <img src="../../../assets/images/banners/journey-mobile.png"
                        class="img img-responsive d-block d-md-none" width="100%" alt="banners journey" />
                    <div class="position-absolute w-100 home-banner">
                        <div class="row h-100 w-100">
                            <div class="col-md-4 col-sm-12">
                                <div class="banner-section">
                                    <div class="align-items-center global_title global_banner_title" role="heading"
                                        aria-level="1">
                                        <span> We Inspire Change </span>
                                    </div>
                                    <div class="global_sub_title global_banner_subtitle mt-3" role="heading"
                                        aria-level="1">
                                        <span> Through Intelligent Technologies, leadership across business processes
                                            and
                                            decades of innovation. </span>
                                    </div>
                                    <div class="col pt-lg-4 mt-3">
                                        <a routerlink="contact" href="contact"
                                            class="global_button  text-left col  text-white white_button" role="button"
                                            aria-label="View Contact Page" tabindex="0">
                                            <div class="dub-arrow"><img
                                                    src="../../../assets/images/button/arrowWhite.png"
                                                    alt="contact to explore" /></div>
                                            EXPLORE
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--====== Banar end here ======-->
<!--====== Journey aspiration meets Start here ====== -->
<div class="feature-large-images-wrapper journey_section_title">
    <div class="container">
        <div class="cybersecurity-about-box">
            <div class="row">
                <div class="col-lg-4">
                    <div class="conact-us-wrap-one managed-it">
                        <div class="heading global_section_header">We believe in driving change that moves the world
                            ahead </div>
                    </div>
                </div>
                <div class="col-lg-7 offset-lg-1">
                    <div class="cybersecurity-about-text global_section_content"> We’re a team of forward thinkers,
                        innovators, pioneers and
                        executors who believe that collective knowledge can transform all our futures
                        with a greater purpose. With our deep-rooted values imbibed in everything we do, we empower our
                        community, clients, team, and customers to amplify ideas,
                        multiply value and experience the best. </div>
                    <div class="col pt-lg-4 mt-3">
                        <a href="capability-statement" class="global_button  text-left " role="button"
                            aria-label="VIEW CAPABILITY STATEMENT" tabindex="0">
                            <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                                    alt="arrow image for Viewcapability" /></div>
                            VIEW CAPABILITY STATEMENT
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--====== Journey aspiration meets End here ======-->

    <section class="timeline-carousel" style="background-color:#000000">
        <h1>Our Leadership </h1>
        <div class="timeline-carousel__item-wrapper" data-js="timeline-carousel">
            <ngx-slick-carousel id="journeySlick" class="leaderJourney">
                <div ngxSlickItem *ngFor="let item of carouselItems"
                    class="timeline-carousel__item timeline-item-image">
                    <div class="timeline-carousel__image" aria-haspopup="true" tabindex="0" role="button">
                        <div class="media-wrapper media-wrapper--overlay" [ngClass]="item.imageClass" role="img"
                            [attr.aria-label]="item.description || 'Timeline image'"></div>
                    </div>
                    <div class="timeline-carousel__item-inner">
                        <span class="year" style="background-color: black" aria-hidden="true" tabindex="-1"
                            role="button">{{ item.name }}</span>
                        <span class="month" aria-hidden="true" tabindex="-1" role="button">{{ item.title }}</span>
                        <p>{{ item.description }}</p>

                        <a (click)="onEmpIdClick(item)" class="read-more " style="color: blueviolet; padding: 6px; display: inline-block;"
                            [attr.aria-label]="'View more details about ' + item.title + ' on LinkedIn'"
                            role="button">VIEW MORE ON LINKEDIN</a>
                        <!-- <a *ngIf="item.link" [href]="item.link" class="read-more " style="color: blueviolet;" target="_blank">VIEW MORE ON LINKEDIN </a> -->

                    </div>
                </div>
            </ngx-slick-carousel>
        </div>
    </section>
    <section class="background-timeline pt-5 pb-5">
        <app-time-line [timelineElements]="timeline" [showContent]="true"></app-time-line>
    </section>

    <!--====== Journey Milestones timelines End here ======-->

    <!--======= Single Blog Item Start ========-->
    <div class="single-blog-item post-list-wrapper xs-list-blog-item border-bottom wow move-up mt-5">
        <div class="row ">
            <div class="col-lg-1"></div>
            <div class="col-lg-5">
                <div class="post-feature blog-thumbnail">
                    <div>
                        <img src="../../../assets/images/techtraining_images/trainingimage1.png"
                            class="trainingintern_subimage w-100 h-100 pt-5" title="techtraining-internship"
                            alt="internship">
                    </div>
                </div>
            </div>
            <div class="col-lg-5">
                <div class="post-info lg-blog-post-info">
                    <div class="global_section_header h4 fw-bold">Who we are</div>
                    <div class=" global_section_content post-excerpt mt-15">
                        <p>We are one of the leading providers of IT solutions through software development and
                            workforce
                            services with 100+ professionals located across the world. Through our journey, we partnered
                            with industry tech leaders to ensure delivery of efficient solutions for clients to benefit
                            from
                            steady reliability and uniqueness across solutions. Our teams are dedicated to apply their
                            competencies worldwide from our technology centers.</p>
                        <p>Our mission is to project client’s thoughts through a best product and help achieve it in a
                            cost
                            effective way.</p>
                        <p>We believe that the privilege to work is a Gift, the power to work is a Blessing and the love
                            towards work is Success. Maganti IT Resources, LLC offers as spectrum of services catering
                            to a
                            wide range of industry needs by leveraging on its domain expertise and strategic alliances
                            with
                            leading technology provides.</p>
                    </div>
                </div>
                <!-- Post info End -->
            </div>
        </div>
    </div>
    <!--===== Single Blog Item End =========-->
    <!--======= Single Blog Item Start ========-->
    <div class="single-blog-item post-list-wrapper xs-list-blog-item border-bottom wow move-up">
        <div class="row ">
            <div class="col-lg-1"></div>
            <div class="col-lg-5">
                <!-- Post info Start -->
                <div class="post-info lg-blog-post-info">
                    <div class="global_section_header post-title h4 fw-bold">
                        What We Do
                    </div>
                    <div class="global_section_content post-excerpt mt-15">
                        <p>
                            Our dedication and passion has led us to become the leading Information Technology company
                            in
                            the USA where we offer a range of industry- leading web and mobile application development
                            solutions using futuristic technologies such as Internet of Things ( IoT), AI-ML, AR-VR,
                            Voice
                            Assistants and Digital Skills & Cloud computing, etc.
                        </p>
                        <p>
                            We are empowered by our certified tech experts and our R&D team, who have always been
                            committed
                            to helping global customers with a plethora of IT services and solutions. Commitment to our
                            team
                            ensures that our clients save huge money on project development with faster delivery.We are
                            committed to the advance and richness of the clients and communities we serve.
                        </p>
                    </div>
                </div>
                <!-- Post info End -->
            </div>
            <div class="col-lg-5">
                <div class="post-feature blog-thumbnail">
                    <div>
                        <img src="../../../assets/images/techtraining_images/trainingimage2.png"
                            class="trainingintern_subimage w-100 h-100" title="techtraining-internship"
                            alt="tech training">
                    </div>
                </div>
            </div>
            <!-- Post Feature End -->
        </div>
    </div>
    <!--===== Single Blog Item End =========-->
    <!--===========  feature-images-wrapper  Start =============-->
    <div class="carporate_joinusmainsection">
        <div class="feature-images-wrapper section-space--ptb_50">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="section-title-wrap text-center carporate_joinussection">
                            <div class="section-sub-title mb-20 global_section_header carporate_blodcontent "
                                role="heading" aria-level="1">Join Us and find your purpose! </div>
                            <div class="heading global_section_content">If you had the chance, how would you make a
                                difference? At Maganti IT,
                                we do much more than just’ business. Learn more about our culture and discover our
                                people and their stories.
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="feature-images__one">
                            <div class="row">
                                <div class="col-lg-4 col-md-6 wow move-up">
                                    <div class="ht-box-images style-01">
                                        <div class="image-box-wrap">
                                            <div class="box-image">
                                                <img src="../../../assets/images/carporategiving_images/mitimage.png"
                                                    alt="corporate giving images" class="img-fluid">
                                            </div>
                                            <div class="content">
                                                <div class="global_sub_title journey-heading carporate_blodcontent text-black"
                                                    aria-level="1" role="heading">Explore Maganti IT</div>
                                                <div class=" global_section_content text">Discover our portfolio of
                                                    services to
                                                    get accelerate growth for your business.
                                                </div>
                                                <div class="circle-arrow">
                                                    <div class="middle-dot"></div>
                                                    <div class="middle-dot dot-2"></div>
                                                    <a routerlink="case-studies" href="case-studies" role="button"
                                                        aria-label="case-studies" tabindex="0">
                                                        <i style="color: #ffff;" class="fa fa-long-arrow-right"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 wow move-up">
                                    <div class="ht-box-images style-01">
                                        <div class="image-box-wrap">
                                            <div class="box-image">
                                                <img src="../../../assets/images/carporategiving_images/connect.png"
                                                    alt="connect" class="img-fluid">
                                            </div>
                                            <div class="content">
                                                <div class="global_sub_title carporate_blodcontent  journey-heading text-black"
                                                    aria-level="1" role="heading">Connect with us</div>
                                                <div class="global_section_content text">Tell us what you’re looking for
                                                    and
                                                    we’ll get you connected to the right people.
                                                </div>
                                                <div class="circle-arrow">
                                                    <div class="middle-dot"></div>
                                                    <div class="middle-dot dot-2"></div>
                                                    <a href="contact" role="button" aria-label="View Contact Page"
                                                        tabindex="0">
                                                        <i style="color: #ffff;" class="fa fa-long-arrow-right"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 wow move-up">
                                    <div class="ht-box-images style-01">
                                        <div class="image-box-wrap">
                                            <div class="box-image">
                                                <img src="../../../assets/images/carporategiving_images/carrers.png"
                                                    alt="careers" class="img-fluid">
                                            </div>
                                            <div class="content">
                                                <div class="global_sub_title carporate_blodcontent journey-heading text-black"
                                                    role="heading" aria-level="1">Careers</div>
                                                <div class="global_section_content text">
                                                    Your career is about what you want to be and who you want to be.
                                                    Explore.
                                                </div>
                                                <div class="circle-arrow">
                                                    <div class="middle-dot"></div>
                                                    <div class="middle-dot dot-2"></div>
                                                    <a href="careers" role="button" aria-label="View Careers Page"
                                                        tabindex="0">
                                                        <i style="color: #ffff;" class="fa fa-long-arrow-right"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="section-under-heading text-center section-space--mt_80"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--===========  feature-images-wrapper  End =============-->